// extracted by mini-css-extract-plugin
export default {"list":"CastPage_list__ievSZ","cast_item":"CastPage_cast_item__sDsPM"};